import { ScheduleRest } from "@/services/rest/schedule.rest";

export class TutorialRustdeskServices {
  constructor(private _schedule = new ScheduleRest()) {}

  getScheduleUserById(id: any) {
    return this._schedule.getScheduleUserById(id).then((response) => {
      return response;
    });
  }
}
